import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

export const NewsComponent: React.FC = () => {
  return (
    <div>
      <Title level={3}>Что нового?</Title>

      <Card
        className='bg-neutral border-[#D9D9D9]'
        classNames={{
          body: '!p-4',
        }}
      >
        <Paragraph>
          Вышло масштабное обновление сервиса — релиз v1.8.1!
        </Paragraph>
        <Paragraph>
          Мы переработали 7 ключевых расчетов противодымной вентиляции и
          полностью обновили аэродинамический расчет. В нем появилась визуальная
          проверка ошибок, гибкое редактирование таблицы, новые блоки для
          расчета избыточного/добавочного давления и улучшенный расчет
          гравитации. А после расчета можно в 1 клик отправить запрос на подбор
          оборудования и отслеживать его статус прямо в личном кабинете.
        </Paragraph>
        <Paragraph>
          Обновления снимают массу рутинных проверок, дают полный контроль над
          расчетами и помогают избежать ошибок в проектах.
        </Paragraph>
      </Card>
    </div>
  );
};
